export const EDUQOR_URL = 'https://eduqor.org'

/** Mention de la plateforme, identique partout : sites, back-office, accueil. */
export function PoweredBy({ className = '' }: { className?: string }) {
  return (
    <a
      className={`powered-by ${className}`.trim()}
      href={EDUQOR_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Propulsé par <strong>eduqor</strong>
    </a>
  )
}
